"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LoadingSpinner = _interopRequireDefault(require("../LoadingSpinner"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _PrimaryText = _interopRequireDefault(require("../../TextElements/BasicTextElements/PrimaryText"));

var _FullScreenLoader = require("./FullScreenLoader.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Used to mask the screen during loading - leaves menu accessable
 */
// intentionally left as a functional component
var FullScreenLoader = function FullScreenLoader(_ref) {
  var _inStyleGuide = _ref._inStyleGuide,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      doneLoading = _ref.doneLoading,
      doneLoadingMessage = _ref.doneLoadingMessage,
      loading = _ref.loading,
      message = _ref.message,
      props = _objectWithoutProperties(_ref, ["_inStyleGuide", "className", "dataTestId", "doneLoading", "doneLoadingMessage", "loading", "message"]);

  return /*#__PURE__*/_react.default.createElement(_FullScreenLoader.StyledFullScreenLoader, _extends({}, props, {
    _inStyleGuide: _inStyleGuide,
    className: className,
    "data-test-id": dataTestId,
    doneLoading: doneLoading,
    isLoading: loading
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-full-screen-loader-spacer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-full-screen-loader-innerWrapper"
  }, doneLoading ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    colorTheme: "primary",
    dataTestId: "full-screen-loader-icon",
    iconName: "check-circle",
    size: "extraLarge"
  }), /*#__PURE__*/_react.default.createElement(_PrimaryText.default, {
    className: "c-full-screen-loader-message",
    dataTestId: "full-screen-loader-done-message"
  }, doneLoadingMessage)) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_LoadingSpinner.default, {
    dataTestId: "full-screen-loader-loading-spinner"
  }), /*#__PURE__*/_react.default.createElement(_PrimaryText.default, {
    className: "c-full-screen-loader-message",
    dataTestId: "full-screen-loader-loading-message"
  }, message)))));
};

FullScreenLoader.propTypes = {
  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** (optional) Indicates if loading has finished as a precursor to showing doneLoadingMessage */
  doneLoading: _propTypes.default.bool,

  /** (optional) Message to show for loading completion screen */
  doneLoadingMessage: _propTypes.default.string,

  /** Indicates if loading is currently in progress */
  loading: _propTypes.default.bool,

  /** Message/Content to display to user while loading */
  message: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]),

  /** A flag specifically for the styleguide - used to turn off fixed positioning */
  _inStyleGuide: _propTypes.default.bool
};
FullScreenLoader.defaultProps = {
  className: '',
  doneLoading: false,
  doneLoadingMessage: 'Done!',
  loading: false,
  message: 'Loading...',
  _inStyleGuide: false
};
var _default = FullScreenLoader;
exports.default = _default;